const DASH = "—";

export function formatMoney(n: number): string {
  return `$${n.toFixed(n < 1 ? 4 : 2)}`;
}

export function formatInteger(n: number): string {
  return n.toLocaleString("en-US");
}

export function formatDuration(ms: number | null): string {
  return ms === null ? DASH : `${(ms / 1000).toFixed(1)}s`;
}

export function formatTokens(input: number | null, output: number | null): string {
  if (input === null && output === null) return DASH;
  return `${input === null ? DASH : formatInteger(input)} → ${output === null ? DASH : formatInteger(output)}`;
}

/** x-tick label from a `Y-m-d` string; rendered in UTC so the date never shifts. */
export function formatChartDay(date: string): string {
  return new Date(`${date}T00:00:00Z`).toLocaleDateString("en-US", {
    month: "short",
    day: "2-digit",
    timeZone: "UTC",
  });
}
